<template>
  <section v-if="loading">
    <loading />
  </section>
  <section class="termo-aceite" v-else>
    <h4 class="h4 color-blue font-weight-bold">Aceite do Termo Aditivo</h4>
    <Aceite
      :voltar="voltar"
      :action-aceite="true"
      :linkVoltar="'/produto/spc-conciliador/resumo'"
      @click="salvarAceite"
      :file="file"
      :aceite="aceite"
      :loading="loadingSave"
      :strLoading="'Aguarde, salvando termo'"
      :descButton="'Confirmar Contratação'"
    />
    <div class="py-5"></div>
  </section>
</template>
<script>
import Aceite from "@/components/aceite/Aceite.vue";
export default {
  name: "TermoAceite",
  components: {
    Aceite,
  },
  props: {
    cpfTitular: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      produto: {
        nome: "SPC Conciliador",
        id: "SPC Conciliador",
      },
      breadcrumb: [
        {
          nome: "SPC Conciliador",
          id: "SPC Conciliador",
          link: "/produto/clube-vantagens/painel",
        },
        {
          nome: "Termo de Aceite",
          id: "termoAceite",
          produto: "SPC Conciliador",
        },
      ],
      voltar: true,
      loading: false,
      linkVoltar: "#",
      linkAceite: "#",
      aceite: "Estou de acordo com o termo acima.",
      file: null,
      tipoReserva: null,
      loadingSave: false,
      eventoId: null,
      rotaVotar: null,
      paramsRota: {},
    };
  },
  methods: {
    async salvarAceite(payload) {
      this.loadingSave = true;
      this.$emit("click", {
        checkAceite: payload.checkAceite,
      });

      if (!sessionStorage.ip) {
        await fetch(process.env.VUE_APP_IP_API + "?format=json")
          .then((x) => x.json())
          .then(({ ip }) => {
            sessionStorage.ip = ip;
          });
      }

      let d = new Date();
      let date = new Date(d.valueOf() - d.getTimezoneOffset() * 60000);

      const dadosTermo = {
        dtVersao: date,
        dtAceite: date,
        ipOrigem: sessionStorage.ip,
        browserData: navigator.appVersion,
      };

      await this.$http
        .post("/api/Conciliador/AceitarTermoSpcConciliador", dadosTermo)
        .then((response) => {
          if (response.status === 200) {
            this.$router.push({ name: "painel-conciliador" });
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push({ name: "login" });
          }
          console.error(error);
          this.$toast.open({
            message: "Erro ao assinar o termo, tente novamente.",
            type: "error",
          });
          this.loading = false;
        });
    },
  },
  async created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.loading = false;

    const dadosPlano = JSON.parse(localStorage.getItem("spc_conciliador"));
    var operadoras = [];

    if (dadosPlano) {
      if (dadosPlano.operadoras.length > 0) {
        dadosPlano.operadoras.forEach((el) => {
          operadoras.push(el.value);
        });
      }

      var dadosConciliador = {
        planoId: dadosPlano.dadosPlano.cod,
        qtdeCNPJs: dadosPlano.qtdCnpj,
        operadorasId: operadoras,
      };
      this.$http
        .post("/api/Conciliador/IncluirSpcConciliador", dadosConciliador)
        .then((response) => {
          this.file = `data:application/pdf; base64, ${response.data.file.fileContents}`;
          this.loading = false;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push({ name: "login" });
          }
          if (error.response.status === 400) {
            this.$toast.open({
              message: error.response.data.mensagem,
              type: "warning",
            });
            this.$router.push({ name: "painel-conciliador" });
          }
          this.loading = false;
        });
    }
  },
};
</script>
